import {Component} from '@angular/core';

@Component({
  selector: 'app-adding-employee',
  templateUrl: './adding-employee.component.html',
  styleUrls: ['./adding-employee.component.scss'],
})
export class AddingEmployeeComponent {}
